import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { ConstructorHeaderType } from '../context/context';
import { DominantEnum, OneConstructorFieldType, OneConstructorType } from '../schema';

import { useConstructor } from './use-constructor';

export function useOneConstructor(id?: number, isUpdate?: boolean) {
  const {
    createOrUpdate,
    methods: { setCreateOrUpdate }
  } = useConstructor();

  const initial: { data: OneConstructorType } = {
    data: {
      id: 0,
      comment: '',
      dominant: DominantEnum.HOUSE
    }
  };

  const { data = initial, ...arg } = useQuery<{ data: OneConstructorType }>(
    ['one-constructor', id],
    async () => {
      const { data } = await $api.get(`/v1/excel-constructor/custom-template/${id}`);

      return { data: data?.data };
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!id,
      onSuccess: ({ data }) => {
        if (isUpdate) {
          const { headers, filters } = (() => {
            let headers: ConstructorHeaderType[] = [];
            const filters: `${string}Filter`[] = [];

            Object.keys(data)?.forEach(key => {
              if (key?.includes('Filter')) {
                filters.push(key as never);
              }

              if (key?.includes('Header')) {
                const header = data[key as keyof typeof data];

                if (Array.isArray(header)) {
                  headers = [
                    ...headers,
                    ...((header?.map((item, i) => ({
                      ...item,
                      key: `${key}_${i}`
                    })) as never) || [])
                  ];
                } else {
                  headers.push({
                    ...(data?.[key as keyof typeof data] as OneConstructorFieldType),
                    key: key as never
                  });
                }
              }
            });

            return { headers: headers?.sort((a, b) => a?.order - b?.order), filters };
          })();

          setCreateOrUpdate({
            ...createOrUpdate,
            filters,
            headers
          });
        }
      }
    }
  );

  return { ...data, ...arg };
}
